<template>
  <AppPageContainer :custom="1600" :min-height="0">
    <app-page-header
      design="new"
      title="AI Flight Tickets"
      compact
    />
    <app-tabs design="new" refined weight="medium" :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </AppPageContainer>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'TechSupportFlightTicketsLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'tech-support-flight-tickets-relevant', label: 'Ticket review' },
        { name: 'tech-support-flight-tickets-issues', label: 'Issues' },
      ],
    }
  },
}
</script>
